import { Box, Grid, Text } from '@factorialco/deprecated-design-system'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

import EmptySpace from './EmptySpace'
import WorkSpaceCard from './WorkSpaceCard'

interface Props {
  workSpaces?: WorkSpaceWithBookingNode[]
}

const WorkSpacesList = ({ workSpaces }: Props) => {
  const groupedWorkSpaces = groupBy(workSpaces, function (workSpace: WorkSpaceWithBookingNode) {
    if (workSpace?.workArea?.location?.name && workSpace?.workArea?.name)
      return `${workSpace?.workArea.location.name}, ${workSpace?.workArea.name}`

    return ''
  })

  if (workSpaces && workSpaces.length < 1) return <EmptySpace />
  return (
    <Box flexGrow gap="s32">
      {map(groupedWorkSpaces, (areaWorkSpaces, group_name) => {
        return (
          <Box key={group_name} gap="s16">
            <Box gap="s8" flexDirection="row" alignItems="flexEnd">
              <Text.Header2>{group_name}</Text.Header2>
              <Text.Normal weight="medium">
                {i18n.tp('space_control.overview.spaces_count', {
                  count: areaWorkSpaces.length,
                })}
              </Text.Normal>
            </Box>
            <Grid component="ul" variant="medium">
              {map(areaWorkSpaces, (workSpace: WorkSpaceWithBookingNode) => (
                <WorkSpaceCard key={workSpace.workSpaceId} workSpace={workSpace} />
              ))}
            </Grid>
          </Box>
        )
      })}
    </Box>
  )
}

export default observer(WorkSpacesList)
